import _ from "lodash";

const nodeType = [
  "uva",
  "ng",
  "c300_pm",
  "ehpmx",
  "sim",
  "uoc",
  "c300h",
  "cn100",
  "sm",
  "smsc",
];
export const isNodeLinux = (poweredVm: any) =>
  _.find(poweredVm?.vmMetadata, (node: any) => {
    if (
      node.key === "Node Type" &&
      nodeType.includes(node.value.toLowerCase())
    ) {
      return true;
    }
    return false;
  });

export const isNodeSim = (selectedVM: any) =>
  _.some(selectedVM, (node: any) => {
    return _.find(node.vmMetadata, (data: any) => {
      if (data.key === "Node Type" && data.value.toLowerCase() === "sim")
        return true;
      else return false;
    });
  });

export const addSelectedID = (selectedVM: any) => {
  const vmId: any = [];
  _.forEach(selectedVM, (data: any) => {
    data && vmId.push(data?.id);
  });
  return vmId;
};

export const formatDate = (date: any) => {
  const options: any = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const formatted = new Date(date).toLocaleDateString("en-US", options);
  const dateParts = formatted
    .substring(0, formatted.indexOf(","))
    .split(" ")
    .reverse()
    .join(" ");
  // Return the formatted date with uppercase month abbreviation and desired format
  const formattedDate =
    dateParts + formatted.substr(formatted.indexOf(",") + 1);
  return formattedDate;
};

export const sortDataByKey = (data: any) => {
  let sortedData;
  if (!data) {
    return [];
  }
  sortedData = data.sort((a: any, b: any) => {
    const x = a.key ? a.key.toLowerCase() : "";
    const y = b.key ? b.key.toLowerCase() : "";
    if (x > y) {
      return 1;
    }
    if (x < y) {
      return -1;
    }
    return 0;
  });
  return sortedData;
};
